import { HorizontalCarousel } from './components/HorizontalCarousel';
import LessonCard from './components/LessonCard';
import Section from './components/Section';

import { MT_DATA_TRACKING } from './utils/constants';

const ExpertHelp = () => (
  <Section
    title="Get expert help"
    description="Watch these videos to learn how to build your website."
  >
    <HorizontalCarousel dataTrackingProps={MT_DATA_TRACKING}>
      <LessonCard video="website" />
      <LessonCard video="simple-editor-overview" />
      <LessonCard video="advanced-editor-overview" />
      <LessonCard video="advanced-editor-step-by-step" />
    </HorizontalCarousel>
  </Section>
);

export { ExpertHelp };
